export default "/images/80f5526fcca7f14fbddba67337816fd8.avif";